import { render } from "./RcsServiceParameter.vue?vue&type=template&id=182f34ba&scoped=true"
import script from "./RcsServiceParameter.vue?vue&type=script&lang=ts"
export * from "./RcsServiceParameter.vue?vue&type=script&lang=ts"

import "./RcsServiceParameter.vue?vue&type=style&index=0&id=182f34ba&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-182f34ba"

export default script